import React from 'react';
import { Lock, Eye, Database, Share2 } from 'lucide-react';

export default function PrivacyPolicy() {
  const policies = [
    {
      icon: <Database className="w-5 h-5" />,
      title: "Data We Collect",
      desc: "We collect wallet addresses, professional credentials for 'Skill Equity' verification, and project contribution logs."
    },
    {
      icon: <Eye className="w-5 h-5" />,
      title: "Public vs. Private",
      desc: "Project contributions and equity stakes are public on the blockchain. Personal identity and contact info remain encrypted and private."
    },
    {
      icon: <Share2 className="w-5 h-5" />,
      title: "Third-Party Sharing",
      desc: "We never sell your data. Data is only shared with production leads and auditors to verify project milestones."
    }
  ];

  return (
    <div className="bg-slate-50 min-h-screen font-sans text-slate-900 pt-24 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-[3rem] p-10 md:p-16 shadow-sm border border-slate-100">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center text-[#c07d3e]">
              <Lock className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-3xl font-extrabold text-[#0a1d2e]">Privacy Policy</h1>
              <p className="text-sm text-slate-400 font-medium">Protecting the Mbogi Community</p>
            </div>
          </div>

          <p className="text-slate-600 mb-12 leading-relaxed">
            At MbogiCapital, we believe in the sovereign ownership of your data. This policy outlines how we handle your information in a decentralized ecosystem.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {policies.map((p, i) => (
              <div key={i} className="p-6 rounded-2xl bg-slate-50 border border-slate-100">
                <div className="text-[#c07d3e] mb-4">{p.icon}</div>
                <h3 className="font-bold text-[#0a1d2e] mb-2">{p.title}</h3>
                <p className="text-xs text-slate-500 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>

          <div className="border-t border-slate-100 pt-8">
            <h2 className="text-lg font-bold mb-4">Your Rights</h2>
            <ul className="list-disc list-inside space-y-2 text-sm text-slate-600">
              <li>Request a copy of your personal data stored off-chain.</li>
              <li>Anonymize your profile from the public directory.</li>
              <li>Withdraw consent for marketing communications.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}